// File: src/pages/RadioPage.js
import React from 'react';
import { useProfile } from '../context/ProfileContext';
import HomeRadioPlayer from '../components/home/HomeRadioPlayer';

const RadioPage = () => {
  const { isDarkMode } = useProfile();

  return (
    <div
      className={`min-h-screen transition-colors duration-500 flex flex-col justify-start items-center px-4 pt-3 sm:pt-6 md:pt-8 pb-24 ${
        isDarkMode ? 'bg-brand-black text-white' : 'bg-slate-50 text-slate-900'
      }`}
    >
      {/* 🌟 UNIFIED RADIO & MAP CARD CONTAINER */}
      <div
        className={`w-full max-w-3xl mx-auto rounded-3xl border p-3 sm:p-4 overflow-hidden shadow-2xl backdrop-blur-md flex flex-col transition-colors ${
          isDarkMode ? 'border-zinc-900 bg-zinc-950/60' : 'border-slate-200 bg-white'
        }`}
      >
        {/* 1. Radio Player (Top Section) */}
        <div className="w-full">
          <HomeRadioPlayer isRadioExpanded={true} />
        </div>

        {/* 2. Section Divider */}
        <div
          className={`w-full my-5 border-t ${
            isDarkMode ? 'border-zinc-800/80' : 'border-slate-200'
          }`}
        />

        {/* 3. Radio Map Viewport (Bottom Section) */}
        <div className="w-full flex flex-col">
          <div className="mb-3 text-center">
            <h3
              className={`text-xl font-black uppercase tracking-widest ${
                isDarkMode ? 'text-brand-pink' : 'text-slate-600'
              }`}
            >
              Where To Tune In!
            </h3>
            <p
              className={`text-[10px] font-bold uppercase tracking-wider ${
                isDarkMode ? 'text-zinc-500' : 'text-slate-400'
              }`}
            >
              Live Radio Network
            </p>
          </div>

          <div className="w-full aspect-[4/3] md:aspect-[16/10] rounded-2xl overflow-hidden shadow-inner">
            <iframe
              frameBorder="0"
              src="https://atomic-frontend.onrender.com/"
              title="Atomic Radio Map Network Sync"
              className={`w-full h-full block ${isDarkMode ? 'bg-black/20' : 'bg-white'}`}
              style={{ borderStyle: 'none' }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RadioPage;